export default __webpack_public_path__ + "static/media/YesVote.000ec2ae.svg";